import axios from "../library/axiosConfig";
import qs from 'qs'

export default {
  // 信用租主页, 获取主页内容
  getLoanCreditPayHome () {
    return axios.post(`/api2/loanCreditPay/home`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 获取信用租授信页面数据
  getCreditStatus (data = {param: {}, config: {}}) {
    return axios.post(`/api2/loanCreditPay/credit?${qs.stringify(data.param)}`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 手动授信
  getActCreditStatus (data = {param: {}, config: {}}) {
    return axios.post(`/loanCreditPay/v1/actCredit?${qs.stringify(data.param)}`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 获取分期记录
  getCreditHistory () {
    return axios.post(`/api2/loanCreditPay/history`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 获取分期详情
  getCreditDetail (data = {param: {}, config: {}}) {
    return axios.post(`/api2/loanCreditPay/detail?${qs.stringify(data.param)}`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 获取还款计划列表
  getRepayList (data) {
    return axios.post(`/api2/loanCreditPay/repayList`, data, {baseURL: axios.defaults.loanUrl})
  },
  //获取信用租申贷结果数据
  loanCreditPayApply(data) {
    return axios.post(`/api2/loanCreditPay/apply?${qs.stringify(data, {allowDots: true})}`, {}, {baseURL: axios.defaults.loanUrl} )
  },
  //获取信用租付款结果数据
  loanCreditPayPayment(data) {
    return axios.post(`/api2/loanCreditPay/payment?${qs.stringify(data, {allowDots: true})}`, {}, {baseURL: axios.defaults.loanUrl} )
  },
  //返回现金贷产品的绑定关系
  queryBindRelation(data) {
    return axios.post('/api2/loanCashBind/queryBindRelation', data, {baseURL: axios.defaults.loanUrl});
  },
  //保存现金贷产品的绑定关系
  saveBindRelation(data) {
    return axios.post('/api2/loanCashBind/saveBindRelation', data, {baseURL: axios.defaults.loanUrl});
  },
  //授权并自动登录拍拍贷
  authorizeAndAutoLogin(data) {
    return axios.post('/api2/loanCashBind/authorizeAndAutoLogin', data, {baseURL: axios.defaults.loanUrl});
  },
  //注册并自动登录拍拍贷
  registerAndAutoLogin(data) {
    return axios.post('/api2/loanCashBind/registerAndAutoLogin', data, {baseURL: axios.defaults.loanUrl});
  },
  //刮奖
  getCoupon(data) {
    return axios.post('/loanCoupon/v1/getCoupon', data, {baseURL: axios.defaults.loanUrl});
  },
  //信用租活动
  getCpayActv(data) {
    return axios.post('/loanCoupon/v1/getCpayActv', data, {baseURL: axios.defaults.loanUrl});
  },
  //信用租反馈
  addCreditPayFeedback(data) {
    return axios.post('/api2/loanCreditPay/addFeedback', data, {baseURL: axios.defaults.loanUrl, json:true});
  },
  // 获取真月付授信
  getRealPayCredit () {
    return axios.post(`/genuinePayMonthly/v1/credit`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 获取真月付授信结果
  getRealPayCreditResult () {
    return axios.post(`/genuinePayMonthly/v1/creditResult`, {}, {baseURL: axios.defaults.loanUrl})
  },
  // 实名认证前获取身份信息
  beforeCreditByAuth () {
    return axios.post(`/loanCreditPay/v1/beforeCreditByAuth`, {}, {baseURL: axios.defaults.loanUrl})
  },
  //该用户是否已授信
  isCredit(data) {
    return axios.post('/api2/loanCreditPay/isCredit', data, {baseURL: axios.defaults.loanUrl});
  }
}



// WEBPACK FOOTER //
// ./src/api/loan.js